module.exports = __webpack_public_path__ + "static/media/Huis-2-5.1a7cf376.jpg";